'use client';

/**
 * Shared amber banner component for URL-based error parameters.
 * Used by SessionClearedError, AuthFailedError, and similar components
 * that display a dismissible error banner with an optional action button.
 */
export function UrlErrorBanner({
  message,
  actionLabel,
  onAction,
}: {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="bg-amber-600 text-white px-8 py-2 text-sm">
      <div className="max-w-4xl mx-auto text-center flex items-center justify-center gap-4">
        <span>{message}</span>
        {actionLabel != null && onAction != null && (
          <button
            onClick={onAction}
            className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-md font-medium transition-colors"
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}
